import { fromJS } from 'immutable';

import { ApiDashboard,UserToken } from '../../../helper/HelperAuth'
import {GetDailyMessageByStatus, GetReadRateByDay, GetSenderAll} from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'


export default (body, type=null) => async (dispatch, getState) => {

    const Authorization = UserToken;

    const url = ApiDashboard + 'read-rate-by-day';

    var query = body

    const argument = {
        method: 'POST',
        headers : {
            'Content-Type':'application/json',
            'Authorization': Authorization,
            'template-type':type,

        },
        body : JSON.stringify(query)
    };

    const response = await doFetch(url,argument);
    var data = fromJS({});
    var responseData = [];
    var finalData = [];
    if(response.ok){
        data = fromJS(await response.json());
        data = data.get('read-rate-by-day');
        for (var i = 0; i < data.size; i++) {
            responseData = []
            let dataDetail = data.get(i)
            responseData['name'] = (dataDetail.get('hari').substring(0, 1)).toUpperCase()+dataDetail.get('hari').substring(1, 3)
            responseData['read'] = parseInt(dataDetail.get('total-read'))
            finalData.push(responseData)
        }
        data = finalData
    }
    
    dispatch({ type: GetReadRateByDay, data:data });
    return data
};